import React from 'react'
import { getFirstNotEmpty } from '@corratech/pylot-utils'
import { useStoreConfig } from 'config'
import { getCanonical } from '../util'
import Head from 'next/head'

export interface BlogCategoryInterface {
    title: string
    meta_title: string
    meta_keywords: string
    meta_description: string
    canonical_url: string
}

export type BlogCategoryProps = {
    blog?: BlogCategoryInterface
    pathname: string
    titleOverride?: string
    descriptionOverride?: string
}

export const BlogCategory = ({
    blog,
    pathname,
    titleOverride,
    descriptionOverride
}: BlogCategoryProps): JSX.Element => {
    const config = useStoreConfig()
    const { seo, base } = config

    const title = getFirstNotEmpty([
        titleOverride,
        blog?.meta_title,
        seo.default.title
    ])

    const description = getFirstNotEmpty([
        descriptionOverride,
        blog?.meta_description,
        seo.default.description
    ])

    return (
        <Head>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="keywords" content={String(blog?.meta_keywords)} />
            <meta name="description" content={String(description)} />
            <link
                rel="canonical"
                href={getCanonical(pathname, base.url.baseUrl)}
            />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta
                property="twitter:domain"
                content={seo.default.twitter?.handle}
            />
            <meta
                property="twitter:url"
                content={getCanonical(pathname, base.url.baseUrl)}
            />
            <meta name="twitter:card" content={seo.default.twitter?.cardType} />
            <meta
                property="og:url"
                content={getCanonical(pathname, base.url.baseUrl)}
            />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta
                name="p:domain_verify"
                content="f000ff9735a3c025e5f36e6833393400"
            />
        </Head>
    )
}
